const truncateString = (length: number) => (value: string) =>
  value.length > length ? value.slice(0, length - 1) + "…" : value;

export const truncateHTMLTitle = truncateString(60);
export const truncateMetaDescription = truncateString(155);
